export const useAuthMe = state => state.auth.me;
export const useAuthLogin = state => state.auth.login;
export const useAuthSignUp = state => state.auth.signUp;
export const useAuthUser = state => state.auth.user;
